import React from "react";
import { Grid } from "@material-ui/core";

import CardCommon from "../../../../components/card/CardCommon";
import ProductCard from "./ProductCard";

export interface ProductListProps {
  products: any[];
  handleSelectProduct: (event: any, item: any) => void;
  updatingProductIds: any;
}

/* Plain product list. Directories are already removed before this point, so
   every entry here is a product card. */
const ProductList: React.FC<ProductListProps> = ({
  products,
  handleSelectProduct,
  updatingProductIds,
}) => {
  return (
    <Grid container spacing={2}>
      {products.map((product: any) => (
        <Grid item md={6} xs={12} lg={4} key={product.id}>
          <CardCommon
            backgroundColor={"default"}
            style={{ borderRadius: "10px", marginTop: "12px" }}
          >
            <ProductCard
              item={product}
              updatingProductIds={updatingProductIds}
              handleSelectProduct={handleSelectProduct}
            />
          </CardCommon>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList;
